import { useRef, useState } from 'react';
import { cn } from '@jk-core/utils';
import styles from './Accordion.module.scss';
import DownIcon from './arrow-down.svg';

interface AccordionProps {
  /**
   * 아코디언의 내용
   */
  children: React.ReactNode;
}

/**
 * 아코디언 컴포넌트
 * 클릭 시 내용이 확장되거나 축소되는 UI 컴포넌트입니다.
 */
export default function Accordion({ children }: AccordionProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  return (
    <div className={cn({
      [styles.accordion]: true,
      [styles['accordion--visible']]: visible,
    })}
    >
      <button
        className={cn({
          [styles.button]: true,
          [styles['button--visible']]: visible,
        })}
        type="button"
        onClick={() => setVisible(!visible)}
      >
        Accordion
        <DownIcon className={cn({
          [styles.button__arrow]: true,
          [styles['button__arrow--up']]: visible,
        })}
        />
      </button>
      <div
        className={cn({
          [styles.wrapper]: true,
          [styles['wrapper--visible']]: visible,
        })}
        style={{ height: visible ? ((contentRef.current?.scrollHeight ?? 0)) : '0px' }}
      >
        <div className={styles.content} ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
}